export default __webpack_public_path__ + "static/media/expand-icon.3e048877.svg";